import { createSlice } from '@reduxjs/toolkit';
import { INVENTORY } from '../types';

const inventorySlice = createSlice({
    name: INVENTORY,
    initialState: {
        addInventoryItemsOptions: { show: false },
        removeAddInventoryItem: false,
        sorting: [],
        filtering: {},
        pagination: {
            pageIndex: 0,
            pageSize: 10
        },
        removeInventoryItemsOptions: { show: false },
        data: {},
        recipe: {
            showRecipes: false,
            rawData: { },
            data: { rows: [], count: 0 },
            recipePage: 0,
            recipeSearch: '',
            updateRecipe: {
                show: false,
                data: {}
            },
            removeRecipeInventoryItem: false,
            recipeInventoryOptions: [],
            viewRecipe: { show: false, data: {} },
            removeRecipe: { show: false }
        }
    },
    reducers: {
        setAddInventoryItems(state, action) {
            state.addInventoryItemsOptions = action.payload;
        },
        setRemoveAddInventoryItemCheck(state, action) {
            state.removeAddInventoryItem = action.payload;
        },
        addInventoryItemsRequest() { },
        getInventoryItemsRequest() { },
        getInventoryItemsSuccess(state, action) {
            state.data = action.payload;
        },
        setInventorySorting(state, action) {
            state.sorting = action.payload;
        },
        setInventoryFiltering(state, action) {
            state.filtering = action.payload;
        },
        setInventoryPagination(state, action) {
            state.pagination = action.payload;
        },
        resetInventoryFilters(state) {
            state.filtering = {};
            state.pagination = {
                pageIndex: 0,
                pageSize: 10
            };
            state.sorting = [];
        },
        updateInventoryItemsRequest() { },
        removeInventoryItemRequest() { },
        setRemoveInventoryItem(state, action) {
            state.removeInventoryItemsOptions = action.payload;
        },
        setShowRecipeCard(state, action) {
            state.recipe.showRecipes = action.payload;
            if (!action.payload) {
                state.recipe.data = state.recipe.rawData;
                state.recipe.recipePage = 0;
                state.recipe.recipeSearch = '';
            }
        },
        fetchRecipesRequest() { },
        fetchRecipesSuccess(state, action) {
            if (!Object.keys(state.recipe.rawData).length) {
                state.recipe.rawData = action.payload;
            }
            state.recipe.data = action.payload;
        },
        setRecipeSearch(state, action) {
            state.recipe.recipeSearch = action.payload;
            state.recipe.recipePage = 0;
        },
        setRecipePage(state, action) {
            state.recipe.recipePage = action.payload;
            state.recipe.recipeSearch = '';
        },
        setUpdateRecipe(state, action) {
            state.recipe.updateRecipe = action.payload;
        },
        getInventoryOptionsRequest() { },
        getInventoryOptionsSuccess(state, action) {
            state.recipe.recipeInventoryOptions = action.payload;
        },
        setRemoveRecipeInventoryItem(state, action) {
            state.recipe.removeRecipeInventoryItem = action.payload;
        },
        manageRecipeRequest() { },
        manageRecipeSuccess(state, action) {
            const payload = action.payload;
            const rawRow = state.recipe?.rawData?.rows || [];
            const row = state.recipe?.data?.rows || [];

            const rawIndex = rawRow.findIndex(obj => obj.id === payload.menuId);
            if (rawIndex !== -1) rawRow[rawIndex].recipes = payload.data;

            const index = row.findIndex(obj => obj.id === payload.menuId);
            if (index !== -1) row[index].recipes = payload.data;
        },
        setViewRecipe(state, action) {
            state.recipe.viewRecipe = action.payload;
        },
        setRemoveRecipe(state, action) {
            state.recipe.removeRecipe = action.payload;
        },
        removeRecipeRequest() {}
    }
});

export const {
    setAddInventoryItems,
    setRemoveAddInventoryItemCheck,
    addInventoryItemsRequest,
    setInventorySorting,
    setInventoryFiltering,
    setInventoryPagination,
    resetInventoryFilters,
    getInventoryItemsRequest,
    getInventoryItemsSuccess,
    updateInventoryItemsRequest,
    removeInventoryItemRequest,
    setRemoveInventoryItem,
    setShowRecipeCard,
    fetchRecipesRequest,
    fetchRecipesSuccess,
    setRecipeSearch,
    setRecipePage,
    setUpdateRecipe,
    getInventoryOptionsRequest,
    getInventoryOptionsSuccess,
    setRemoveRecipeInventoryItem,
    manageRecipeRequest,
    manageRecipeSuccess,
    setViewRecipe,
    setRemoveRecipe,
    removeRecipeRequest
} = inventorySlice.actions;

export const inventoryReducer = inventorySlice.reducer;
